const Portfolio_data = [
  {
    id: 1,
    category: "Website - WordPress ",
    totalLike: "Online shopping website using WordPress.",
    title: "VAIN ",
    image: require("../pic/vain.png"),
    url: "http://vain.infinityfreeapp.com/",
  },
  {
    id: 2,
    category: "Website - MERN",
    totalLike: "Z-Rent a car website, developed using Node.JS as backend, React as frontend, and MongoDB as database.",
    title: "Z-Rent a Car",
    image: require("../pic/zrent.png"),
    url: "https://zrentcar.herokuapp.com/",
  },
  {
    id: 3,
    category: "Website - MERN & Flask",
    totalLike: "The Languages used are\n\n 1- The prediction stage: Python and Flask.\n\n 2- Backend languages: Express.JS, NodeJS, and MongoDB.\n\n  3- Front-end languages: React, CSS, Html, and JavaScript.",
    title: "Car Dealer App ",
    image: require("../pic/predictor.png"),
    url: "https://cardealerpriceprediction.herokuapp.com/",
  },
  {
    id: 4,
    category: "Website - React and Laravel",
    totalLike: "The website will be developed using Laravel as backend, React as frontend, and PHPMyAdmin as database.",
    title: "Financial Tracker ",
    image: require("../pic/finance.png"),
    url: "https://react-financial.herokuapp.com/",
  }
]
export default Portfolio_data
